'use client';

import { useCallback } from 'react';
import { CatPagination } from 'components/blocks-components';
import { SearchParams } from '../types';
import { BlocksPageChangeEvent } from 'blocks-nextjs/blocks-web-components/events';
import { DEFAULT_PAGE_SIZE } from 'services/utils/constants';
import { useBreakpoint } from '@cat-ecom/pcc-components';
import { useMyEquipmentContext } from '../my-equipment-search-pagination-context';
import { ViewPaginationLabel } from './view-pagination-label';
import { PAGE_BREAKPOINTS } from 'constants/common';

export interface PaginationProps {
  searchParams: SearchParams;
  productCount: number;
}

const Pagination = ({ searchParams, productCount }: PaginationProps) => {
  const isLG = useBreakpoint(PAGE_BREAKPOINTS.LG);
  const { setPage, page } = useMyEquipmentContext();
  const onPageChange = useCallback(
    (e: BlocksPageChangeEvent) => {
      setPage(String(e.detail.pageNumber));
    },
    [setPage]
  );
  const currentPage = isNaN(Number(page)) ? 1 : Number(page);
  const pageSize = isNaN(Number(searchParams.pageSize))
    ? DEFAULT_PAGE_SIZE
    : Number(searchParams.pageSize);

  return (
    <CatPagination
      data-testid="search-pagination"
      hidePageSize
      currentItem={currentPage}
      pageSize={pageSize}
      totalRecords={productCount}
      onBlPageChange={onPageChange}
      variant={isLG ? null : 'in-page'}
    >
      <ViewPaginationLabel
        pageSize={pageSize}
        currentPage={currentPage}
        productCount={productCount}
      />
    </CatPagination>
  );
};

export default Pagination;
